const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function formatBillingDate(value, {locale = 'en-CA', timeZone} = {}) {
  if (!value) return 'Not available yet';
  const normalized = DATE_ONLY_PATTERN.test(value) ? `${value}T12:00:00.000Z` : value;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return 'Not available yet';

  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    ...(timeZone ? {timeZone} : {})
  }).format(date);
}

export function getSubscriptionDisplayDate({
  status,
  cardFreeTrialEndsAt,
  trialEndsAt,
  currentPeriodEnd
} = {}) {
  if (status === 'trialing') {
    return cardFreeTrialEndsAt || trialEndsAt || currentPeriodEnd;
  }

  return currentPeriodEnd;
}
